export * from './exam-table.component';
